exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-buttons *{\n    display: inline;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/ventas/nota-credito-add/nota-credito-add.component.css
// module id = ../../../../../src/app/components/ventas/nota-credito-add/nota-credito-add.component.css
// module chunks = main